import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/login';
import Home from '@/views/home';
import TasasIndex from '@/views/tasas';
import Tasa from '@/views/tasas/Tasa';
import Tasas from '@/views/tasas/Tasas';
import PagoTasas from '@/views/tasas/PagoTasas';
import PagoTasa from '@/views/tasas/PagoTasa';
import ConsultaPagoTasas from '@/views/tasas/ConsultaPagoTasas';
import ConsultaPagoTasa from '@/views/tasas/ConsultaPagoTasa';
import InfoPago from '@/views/tasas/InfoPago';
import Justificante from '@/views/justificante/Justificante';
import CuotasIndex from '@/views/cuotas';
import Cuotas from '@/views/cuotas/Cuotas';
import CuotaGas from '@/views/cuotas/CuotaGas';
import CuotaElec from '@/views/cuotas/CuotaElec';
import { Error, Page401, Page403, Page404 } from '@/views/errorPage';

Vue.use(Router);

// https://router.vuejs.org/guide/essentials/nested-routes.html not working
const routerMap = [
  { path: '/', component: Home, name: 'home' },
  { path: '/login', component: Login, hidden: false, name: 'login' },
  { path: '/tasas/', component: TasasIndex, name: 'tasasIndex' },
  { path: '/tasas/presentacion', component: Tasa, name: 'tasa' },
  { path: '/tasas/consulta', component: Tasas, name: 'tasas' },
  { path: '/tasas/pago', component: PagoTasas, name: 'pagotasas' },
  { path: '/tasas/info-pago', component: InfoPago, name: 'infopago', hidden: true, props: true },
  {
    path: '/tasas/presentar-pago',
    component: PagoTasa,
    name: 'pagotasa',
    props: true,
    hidden: false
  },
  { path: '/tasas/consulta-pagos', component: ConsultaPagoTasas, name: 'consultapagotasas' },
  {
    path: '/tasas/consulta-pago',
    component: ConsultaPagoTasa,
    name: 'consultapagotasa',
    props: true
  },
  {
    path: '/tasas/presentacion-tasa/ayudaE',
    beforeEnter() {
      window.open('/doc/TasasElec.pdf', '_blank');
    }
  },
  {
    path: '/tasas/presentacion-tasa/ayudaG',
    beforeEnter() {
      window.open('/doc/TasasGas.pdf', '_blank');
    }
  },
  { path: '/cuotas', component: CuotasIndex, name: 'cuotasIndex' },
  { path: '/cuotas/presentacion-Gas', component: CuotaGas, name: 'cuotaGas' },
  { path: '/cuotas/presentacion-Electricidad', component: CuotaElec, name: 'cuotaElec' },
  { path: '/cuotas/consulta', component: Cuotas, name: 'cuotas' },
  {
    path: '/cuotas/presentacion-cuota/ayudaE',
    beforeEnter() {
      window.open('/doc/CuotasElec2004.pdf', '_blank');
    }
  },
  {
    path: '/declaracion/justificante',
    component: Justificante,
    name: 'justificante',
    props: true,
    hidden: true
  },
  {
    path: '/entidades-financieras',
    beforeEnter() {
      window.open('https://www2.agenciatributaria.gob.es/es13/h/pago007h.html', '_blank');
    }
  },
  {
    path: '/salir',
    beforeEnter() {
      window.open('https://sede.cnmc.gob.es/', '_parent');
    }
  },
  { path: '/error', component: Error, name: 'error' },
  { path: '/401', component: Page401, hidden: true },
  { path: '/403', component: Page403, hidden: true },
  { path: '/404', component: Page404, hidden: true },
  { path: '*', redirect: '/404', hidden: true }
];

export default new Router({
  routes: routerMap,
  mode: 'history'
});
